import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Draggable } from 'gsap/Draggable'
import { InertiaPlugin } from 'gsap/InertiaPlugin'

gsap.registerPlugin(Draggable, InertiaPlugin, ScrollTrigger)

class Timeline {
  constructor() {
    if (!document.querySelector('.c-timeline')) return
    this.setTimeline()
    this.setDrag()
    this.goToMilestone(0)
  }

  setTimeline() {
    this.milestones = document.querySelectorAll('.c-timeline__milestone')
    this.contents = document.querySelectorAll('.c-timeline__content')
    this.buttonSpans = document.querySelectorAll('.c-timeline__button span')

    const duration = 1 / (this.milestones.length - 1) / 2
    // console.log(duration)

    gsap.set([...this.milestones, ...this.contents], { opacity: 0 }, '0')
    gsap.set([this.milestones[0], this.contents[0]], { opacity: 1 }, '0')
    gsap.set(
      this.buttonSpans[0],
      {
        scale: 2,
        backgroundColor: '#0066FF',
      },
      '0',
    )

    this.timeline = gsap.timeline({ paused: true, ease: 'none' })
    this.timeline.addLabel('milestone-0')

    this.milestones.forEach((milestone, index) => {
      if (index === 0) return

      const milestoneLabel = `milestone-${index}`
      const labelPosition = (1 / (this.milestones.length - 1)) * index
      // console.log(labelPosition, 'labelPosition')

      const lastSpan = this.buttonSpans[index - 1]
      const lastContent = this.contents[index - 1]
      const lastMilestone = this.milestones[index - 1]
      const content = this.contents[index]
      const span = this.buttonSpans[index]

      const step1 = (index - 1) * duration * 2
      const step2 = (index - 1) * duration * 2 + duration

      // console.log(milestoneLabel, labelPosition, step1, step2)

      this.timeline.to(
        [lastMilestone, lastContent],
        {
          opacity: 0,
          duration,
        },
        step1,
      )

      this.timeline.to(
        [lastSpan],
        {
          scale: 1,
          backgroundColor: '#000',
          duration,
        },
        step1,
      )

      this.timeline.to(
        [milestone, content],
        {
          opacity: 1,
          duration,
        },
        step2,
      )

      this.timeline.to(
        span,
        {
          scale: 2,
          backgroundColor: '#0066FF',
          duration,
        },
        step2,
      )
    })

    // console.log(this.timeline.duration(), 'total duration')

    this.prev = document.querySelector('.c-timeline__arrow.--left')
    this.next = document.querySelector('.c-timeline__arrow.--right')

    this.prev.addEventListener('click', () => {
      this.goToMilestone(this.previousIndex())
    })

    this.next.addEventListener('click', () => {
      this.goToMilestone(this.nextIndex())
    })

    const buttons = document.querySelectorAll('.c-timeline__button')
    buttons.forEach((button, i) => {
      button.addEventListener('click', () => {
        const { index } = button.dataset
        this.goToMilestone(index)
      })
    })
  }

  nextIndex() {
    // console.log(this.currentIndex, 'currentIndex')
    return this.currentIndex === this.milestones.length - 1
      ? this.milestones.length - 1
      : this.currentIndex + 1
  }

  previousIndex() {
    return this.currentIndex === 0 ? 0 : this.currentIndex - 1
  }

  goToMilestone(index) {
    if (index === 0) {
      this.prev.style.opacity = 0
    } else {
      this.prev.style.opacity = 1
    }

    if (index === this.milestones.length - 1) {
      this.next.style.opacity = 0
    } else {
      this.next.style.opacity = 1
    }

    this.currentIndex = index
    gsap.to(this.line, {
      x: this.points[index],
      duration: 0.3,
      ease: 'power2.out',

      onComplete: () => {
        this.draggable.update()
        const { x } = this.draggable
        const progress = this.progressMap(x)
        this.timeline.tweenTo(progress)
        // console.log(progress, 'progress')
      },
    })
  }

  setDrag() {
    this.wrapper = document.querySelector('.c-timeline__wrapper')
    this.line = document.querySelector('.c-timeline__line')

    const minX = this.wrapper.offsetWidth * 0.5
    const maxX = this.wrapper.offsetWidth * 0.5 - this.line.offsetWidth

    const range = gsap.utils.mapRange(minX, maxX, 0, 1)
    const clamp = gsap.utils.clamp(0, 1)
    this.progressMap = gsap.utils.pipe(range, clamp)
    gsap.set(this.line, { x: this.wrapper.offsetWidth * 0.5 })

    this.points = []
    const delta = (minX - maxX) / (this.milestones.length - 1)
    for (let i = 0; i < this.milestones.length; i++) {
      this.points.push(minX - delta * i)
    }

    // console.log(this.points)

    const [draggable] = Draggable.create(this.line, {
      type: 'x',
      // inertia: true,
      snap: {
        x: this.points,
      },
      onDrag: () => {
        const { x } = this.draggable
        const progress = this.progressMap(x)

        // console.log('progress', progress)

        this.timeline.progress(progress)
      },
      bounds: {
        minX,
        maxX,
      },
    })

    this.draggable = draggable
  }
}

export default Timeline
